import { Action, createReducer, on } from '@ngrx/store';

import * as featureActions from './shared.actions';
import { IBrand } from '../models/brands.models';
import * as sharedsActions from './shared.actions';
import { ITag } from '../models/tags.models';
import { ICategory } from '../models/catagories.models';
import { IObjectCustomFields } from '../models/custom-fields.models';

export interface SharedState {
  isAppLoading: boolean;
  brands: IBrand[];
  tags: ITag[];
  categories: ICategory[];
  currentLang: string;
  objectCustomFields: IObjectCustomFields;
}
export const initialAuthState: SharedState = {
  isAppLoading: false,
  brands: [],
  tags: [],
  categories: [],
  currentLang: localStorage.getItem('lang') || 'en',
  objectCustomFields: {
    values: {},
    definitions: [],
  },
};

const featureReducer = createReducer(
  initialAuthState,
  on(featureActions.SetLoading, (state, action) => ({
    ...state,
    isAppLoading: action.isAppLoading,
  })),
  on(sharedsActions.FetchAllBrandsSuccess, (state, action) => ({
    ...state,
    brands: action.brands,
  })),
  on(sharedsActions.FetchAllTagsSuccess, (state, action) => ({
    ...state,
    tags: action.tags,
  })),
  on(sharedsActions.FetchAllCategoriesSuccess, (state, action) => ({
    ...state,
    categories: action.categories.data,
  })),
  on(sharedsActions.SetLanguage, (state, action) => ({
    ...state,
    currentLang: action.language,
  })),
  on(sharedsActions.GetObjectCustomFieldsSuccess, (state, action) => ({
    ...state,
    objectCustomFields: action.objectCustomFields,
  }))
);

export function sharedReducer(state: SharedState | undefined, action: Action) {
  return featureReducer(state, action);
}
